import React, { Component } from 'react'
import PropTypes from 'prop-types'

export class Country extends Component {

    static propTypes = {
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]).isRequired,
        getLabel: PropTypes.func.isRequired,
    }

    render() {
        const label = this.props.getLabel(this.props.value)

        return (
            <span title={ label }>
                { label }
            </span>
        )
    }
}
